import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import BillBrandLogo from '@sputnik/components/BillBrandLogo'
import CustomerAssistanceButton from '@sputnik/components/CustomerAssistanceButton'
import ImageWrapper from '@sputnik/components/ImageWrapper'

import styles from './styles.module.scss'

interface AfterSubmitInfoPageLayoutProps {
  marketing: React.ReactNode
  title: React.ReactNode
  infoContent: React.ReactNode
  buttons?: React.ReactNode
  link?: React.ReactNode
  imageName: string
}

const AfterSubmitInfoPageLayout = ({
  marketing,
  title,
  infoContent,
  buttons,
  link,
  imageName,
}: AfterSubmitInfoPageLayoutProps) => {
  const [getClassName] = useNameFormatter('AfterSubmitInfoPageLayout')
  return (
    <div className={styles[getClassName('')]}>
      <BillBrandLogo />
      <div className={styles[getClassName('wrapper')]}>
        <div className={styles[getClassName('content')]}>
          <div>
            <ImageWrapper
              className={getClassName('')}
              imageName={imageName}
            />
          </div>
          <div className={styles[getClassName('content-title')]}> {title} </div>
          <div className={styles[getClassName('content-info-content')]}> {infoContent} </div>
          <div className={styles[getClassName('content-buttons')]}> {buttons} </div>
          <div className={styles[getClassName('content-link')]}> {link} </div>
        </div>
      </div>
      {marketing}
      <CustomerAssistanceButton />
    </div>
  )
}

export default AfterSubmitInfoPageLayout
